import { createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { FC } from 'react';

interface SummaryInfoItemProps {
  label: string;
  value: string | string[];
  highlight?: boolean;
  isLast?: boolean;
  'data-testid'?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    itemContainer: {
      padding: theme.spacing(1, 3),
      '&:nth-child(odd)': {
        backgroundColor: theme.palette.grey[50],
      },
    },
    label: {
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    value: {
      color: theme.palette.text.primary,
    },
    highlight: {
      fontWeight: 400,
      color: theme.palette.primary.main,
    },
  }),
);

const SummaryInfoItem: FC<SummaryInfoItemProps> = ({
  label,
  value,
  highlight = false,
  isLast = false,
  'data-testid': dataTestId,
}) => {
  const classes = useStyles();

  // Render array values on separate lines
  const renderValue = () => {
    if (Array.isArray(value)) {
      return value.map((item, index) => (
        <Typography
          key={index}
          variant="body1"
          className={clsx(classes.value, { [classes.highlight]: highlight })}
          component="div"
        >
          {item}
        </Typography>
      ));
    }
    return (
      <Typography variant="body1" className={clsx(classes.value, { [classes.highlight]: highlight })}>
        {value}
      </Typography>
    );
  };

  return (
    <Grid container className={classes.itemContainer} spacing={2} data-testid={dataTestId}>
      <Grid item xs={12} sm={3}>
        <Typography variant="body1" className={classes.label}>
          {label}:
        </Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        {renderValue()}
      </Grid>
    </Grid>
  );
};

export default SummaryInfoItem;
